export const CREATE_ATTENDANT_SETTING_REQUESTED = 'CREATE_ATTENDANT_SETTING_REQUESTED'
export const CREATE_ATTENDANT_SETTING_SUCCEEDED = 'CREATE_ATTENDANT_SETTING_SUCCEEDED'
export const CREATE_ATTENDANT_SETTING_FAILED = 'CREATE_ATTENDANT_SETTING_FAILED'

export const GET_ATTENDANT_SETTINGS_REQUESTED = 'GET_ATTENDANT_SETTINGS_REQUESTED'
export const GET_ATTENDANT_SETTINGS_SUCCEEDED = 'GET_ATTENDANT_SETTINGS_SUCCEEDED'
export const GET_ATTENDANT_SETTINGS_FAILED = 'GET_ATTENDANT_SETTINGS_FAILED'

export const UPDATE_ATTENDANT_SETTING_REQUESTED = 'UPDATE_ATTENDANT_SETTING_REQUESTED'
export const UPDATE_ATTENDANT_SETTING_SUCCEEDED = 'UPDATE_ATTENDANT_SETTING_SUCCEEDED'
export const UPDATE_ATTENDANT_SETTING_FAILED = 'UPDATE_ATTENDANT_SETTING_FAILED'

export const REMOVE_ATTENDANT_SETTING_REQUESTED = 'REMOVE_ATTENDANT_SETTING_REQUESTED'
export const REMOVE_ATTENDANT_SETTING_SUCCEEDED = 'REMOVE_ATTENDANT_SETTING_SUCCEEDED'
export const REMOVE_ATTENDANT_SETTING_FAILED = 'REMOVE_ATTENDANT_SETTING_FAILED'
